<template>
  <div class="d-flex w-full h-full justify-content-center align-items-center py-5">
    <div v-if="!error" class="text-muted">Redirecting…</div>
    <h2 v-else>Something went wrong</h2>
  </div>
</template>
<script setup lang="ts">
import { ref, onBeforeMount } from 'vue';
import { useRouter } from 'vue-router';
import { JUMP_TYPES, type JumpType } from '@/func/entityLinks';
import { useAutopilotRouteReady } from '@/composables/useAutopilotRouteReady';

// claim the jump so open_link stays withheld across the redirect; only call ready() on error
// paths that stay on this page. a successful replace unmounts us after the next hop has claimed.
const routeReady = useAutopilotRouteReady();

const router = useRouter();
const props = defineProps<{ type: JumpType; info: string }>();

const error = ref(false);

function fail() {
  error.value = true;
  routeReady();
}

onBeforeMount(() => {
  if (!(JUMP_TYPES as readonly string[]).includes(props.type)) {
    fail();
    return;
  }

  if (props.type === 'order') {
    if (!props.info) {
      fail();
      return;
    }
    return router.replace({ name: 'order.detail.info', params: { id: props.info } });
  }

  if (props.type === 'company') {
    if (!props.info) {
      fail();
      return;
    }
    return router.replace({ name: 'settings.company.details', params: { id: props.info } });
  }

  if (props.type === 'account') {
    if (!props.info) {
      fail();
      return;
    }
    return router.replace({ name: 'settings.accounts.detail', params: { id: props.info } });
  }

  if (props.type === 'vbudget') {
    return router.replace({ name: 'billing.vbudgets' });
  }

  if (props.type === 'poolmirror') {
    if (!props.info) {
      return router.replace({ name: 'poolmirror.list' });
    }
    return router.replace({ name: 'poolmirror.detail', params: { id: props.info } });
  }

  if (props.type === 'candidate') {
    if (!props.info) {
      fail();
      return;
    }
    return router.replace({ name: 'candidate.detail', params: { id: props.info } });
  }

  if (props.type === 'ejm_job') {
    return router.replace({ name: 'external_job_markets.list' });
  }

  if (props.type === 'promptsuite_app') {
    if (!props.info) {
      return router.replace({ name: 'promptsuite.apps' });
    }
    return router.replace({ name: 'promptsuite.app.detail', params: { id: props.info } });
  }

  fail();
});
</script>
